/**
 * Amplify v6 Cognito configuration.
 *
 * Values come from `.env` at the project root. See `.env.example` for the
 * required keys. Both build pipelines substitute these at compile time:
 *   - Metro (mobile): react-native-dotenv intercepts `import from '@env'`.
 *   - Webpack (web):  alias `@env` → src/lib/envWeb.js, which reads
 *                     `process.env.X` that DefinePlugin substitutes.
 *
 *   AWS Console → Cognito → User pools → <your pool>
 *     - User pool ID   → "us-east-1_XXXXXXXXX"
 *     - App client ID  → "App integration" tab → app client (no client secret)
 *
 * The app client MUST be configured WITHOUT a client secret — Amplify's
 * public-client auth flow does not support secrets.
 */
import 'react-native-get-random-values';
import { Amplify } from 'aws-amplify';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import { COGNITO_USER_POOL_ID, COGNITO_USER_POOL_CLIENT_ID } from '@env';

export const cognitoConfig = {
  userPoolId:       COGNITO_USER_POOL_ID       || '',
  userPoolClientId: COGNITO_USER_POOL_CLIENT_ID || '',
};

let configured = false;

export function configureAmplify() {
  if (configured) return;
  configured = true;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId:       cognitoConfig.userPoolId,
        userPoolClientId: cognitoConfig.userPoolClientId,
        // Early access uses email sign-in. The User Pool MUST be configured
        // with email as a sign-in alias (or set as the username attribute).
        loginWith: { email: true },
      },
    },
  });

  // Persist tokens in AsyncStorage so sessions survive app restarts.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(AsyncStorage);
}

export function isCognitoConfigured() {
  return Boolean(cognitoConfig.userPoolId && cognitoConfig.userPoolClientId);
}
